// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Typography } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { Query } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import Container from '../../common/container/Container'
import { EditableProvider } from '../../common/context/EditableContext'
import DateStepper from '../../common/date/DateStepper'
import type { WithDateProps } from '../../common/date/withDate'
import withDate from '../../common/date/withDate'
import Loader from '../../common/loader/Loader'
import { RestrictedProvider } from '../auth/RestrictedContext'
import Header from '../header/Header'
import { i18n } from '../index'
import StaffingPlan from '../staffingPlan/StaffingPlan'
import type { Station } from '../station/stationTypes'
import withActiveStation from '../station/withActiveStation'
import DailyManagementForm from './DailyManagementForm'
import { fetchDailyManagement } from './dailyManagementQueries'

import css from './dailyManagementPage.css'

type DailyManagementPageProps = WithDateProps & {
  activeStation: Station
  location: any
}

type DailyManagementPageState = {
  isDailyManagementSubmitted: boolean
}

@withDate()
@withActiveStation
class DailyManagementPage extends React.PureComponent<DailyManagementPageProps, DailyManagementPageState> {
  state = {
    isDailyManagementSubmitted: false,
  }
  staffPlanRef = React.createRef()

  componentDidMount() {
    if (this.props.location.hash === '#miehistosunnitelma') {
      this.scrollToStaffPlan()
    }
  }

  onDailyManagementSubmit = () => {
    this.setState(
      {
        isDailyManagementSubmitted: true,
      },
      () => {
        const staffingPlanCancelEditButton: HTMLButtonElement = document.querySelector('.staffing-plan-cancel-edit')
        staffingPlanCancelEditButton?.click()
      },
    )
  }
  scrollToStaffPlan = () => {
    setTimeout(() => {
      window.scrollTo({
        left: 0,
        top: this.staffPlanRef.current.offsetTop,
        behavior: 'smooth',
      })
    }, 1000)
  }
  scrollToPosition = (position) => {
    setTimeout(() => {
      window.scrollTo({
        left: 0,
        top: position,
        behavior: 'smooth',
      })
    }, 500)
  }

  render() {
    const { activeStation, date, onDateChange } = this.props
    const isInThePast = moment().diff(date, 'days') > 0
    return (
      <Query
        query={fetchDailyManagement}
        variables={{
          stationId: activeStation.id,
          date,
        }}
        fetchPolicy='network-only'
      >
        {({ loading, error, data }) => {
          const incentiveSalesTargetSum =
            data?.dailyManagement?.salesIncentiveTargets
              ?.filter((target) => target.shift !== 'ExpressCheckout')
              .reduce((sum, target) => sum + target.target, 0) ?? null
          const hasExpressCheckout =
            data?.dailyManagement?.salesIncentiveTargets?.some((target) => target.shift === 'ExpressCheckout') ?? false
          return (
            <div className={css.component}>
              <RestrictedProvider requiredPermission='edit_dailyManagement'>
                <Header title={i18n.t('dailyPlanning.header')} />
                <Container>
                  <Typography variant='h6' component='h1' textAlign='center' fontWeight={700}>
                    {i18n.t('dailyManagement.heading.dailyManagement')}
                  </Typography>
                  <div>
                    <DateStepper
                      date={date}
                      onDateChange={onDateChange}
                      className={css.dateBar}
                      scrollToBottom={true}
                    />
                  </div>
                  <Loader
                    {...{
                      loading,
                      error,
                    }}
                  >
                    <EditableProvider>
                      {({ isEditable, toggleEditable }) => (
                        <div className={css.dailyManagement}>
                          <div className={css.dailyManagementForm}>
                            <DailyManagementForm
                              toggleEditable={toggleEditable}
                              isEditable={isEditable}
                              onSubmit={this.onDailyManagementSubmit}
                              data={{
                                date,
                                ...(data.dailyManagement || {}),
                              }}
                              date={date}
                              isInThePast={isInThePast}
                              hasExpressCheckout={hasExpressCheckout}
                            />
                          </div>
                        </div>
                      )}
                    </EditableProvider>
                  </Loader>
                  <div className={css.staffingPlan} ref={this.staffPlanRef}>
                    <Typography variant='h6' gutterBottom>
                      {i18n.t('dailyManagement.heading.staffingPlan')}
                    </Typography>
                    <StaffingPlan
                      date={date}
                      isInThePast={isInThePast}
                      chainIncentiveSalesTarget={data?.dailyManagement?.chainIncentiveSalesTarget ?? 0}
                      incentiveSalesTargetSum={incentiveSalesTargetSum}
                    />
                  </div>
                </Container>
              </RestrictedProvider>
            </div>
          )
        }}
      </Query>
    )
  }
}

export default withRouter(DailyManagementPage)
